import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import { CACHE_KEYS, TTL, peekCache, setCache, warmCache } from '../services/pageDataCache';

export function useKlantenWeekAudience(days = 7, autoLoad = true) {
  const cacheKey = CACHE_KEYS.audienceWeek(days);
  const initial = peekCache(cacheKey, TTL.AUDIENCE_TTL * 3);
  const [data, setData] = useState(initial);
  const [loading, setLoading] = useState(autoLoad && !initial);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/marketing/popup/audience-week?days=${days}`);
      setCache(cacheKey, res.data);
      setData(res.data);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  }, [cacheKey, days]);

  useEffect(() => {
    if (!autoLoad) return undefined;
    let cancelled = false;
    const cached = peekCache(cacheKey, TTL.AUDIENCE_TTL * 3);
    if (cached) {
      setData(cached);
      setLoading(false);
    } else {
      setLoading(true);
    }
    warmCache(
      cacheKey,
      () => api.get(`/marketing/popup/audience-week?days=${days}`).then((r) => r.data),
      TTL.AUDIENCE_TTL
    )
      .then((next) => {
        if (!cancelled && next) setData(next);
      })
      .catch((e) => {
        if (!cancelled && !cached) setError(e.response?.data?.error || e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [autoLoad, cacheKey, days]);

  return { data, loading, error, reload };
}
